import React from 'react';
import styled from 'styled-components';
import { Panel, Box } from '@cko/primitives';
import { SearchSummary } from './SearchSummary';
import { ExampleList } from './ExampleList';
import { SuggestionList } from './SuggestionList';
import { SearchHelp } from './SearchHelp';
import { Portal } from '../../../_deprecated/Portal';
const Menu = styled(Panel) `
  position: absolute;
  z-index: 100;
  ${({ x, y, isOpen }) => `
    display: ${isOpen ? 'block' : 'none'};
    top: ${y}px;
    left: ${x - 1}px;
  `};
`;
export const SearchMenu = ({ width, query, onSubmit, isOpen, position, entries, helpUrl, }) => {
    const showSearchPrompt = query.match(/.+(:|=).+/gi);
    return (React.createElement(Portal, { as: "div" },
        React.createElement(Menu, { "data-testid": "search-menu", p: "var(--layout-sandgrain)", width: width, border: "var(--base-border-secondary)", borderTop: "var(--border-b-sandgrain)", borderRadius: "var(--border-r-sandgrain) var(--border-r-sandgrain) var(--border-r-seed) var(--border-r-seed)", isOpen: isOpen, ...position },
            React.createElement(Box, { borderTop: "var(--base-border-secondary)" },
                showSearchPrompt && React.createElement(SearchSummary, { query: query, onClick: onSubmit }),
                React.createElement(SuggestionList, { title: showSearchPrompt ? 'Add more criteria' : 'Suggestions', suggestions: entries.suggestions }),
                React.createElement(ExampleList, { title: "Examples", examples: entries.examples })),
            helpUrl && React.createElement(SearchHelp, { url: helpUrl }))));
};
